import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { KeycloakService } from 'keycloak-angular';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);

  // 1. PROTEÇÃO CONTRA SSR: Se rodar no servidor, deixa a requisição passar direto
  if (!isPlatformBrowser(platformId)) {
    return next(req);
  }

  // 2. AGRESSIVIDADE WEBVIEW: Verifica se o token injetado pelo Flutter existe na janela viva
  const flutterToken = (globalThis.window as any).flutter_token_value ||
    (globalThis.window as any).mobileToken ||
    sessionStorage.getItem('flutter_token') ||
    sessionStorage.getItem('auth_token');

  if (flutterToken) {
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${String(flutterToken).trim()}`,
      },
    });
    return next(authReq);
  }


  // 3. FLUXO WEB TRADICIONAL (PC): Se não for WebView, segue com a lógica padrão do Keycloak
  const keycloak = inject(KeycloakService);

  return from(keycloak.updateToken().catch(() => false)).pipe(
    switchMap(() => keycloak.getToken()),
    switchMap((token) => {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next(authReq);
    }),
  );
};
